import React, { FunctionComponent } from 'react'
import { Documents } from '../Cards/Documents'

interface ConstructionPanelProps {
  portfolioHomeId: string
}
export const DocumentsPanel: FunctionComponent<React.PropsWithChildren<ConstructionPanelProps>> = ({
  portfolioHomeId
}) => <Documents portfolioHomeId={portfolioHomeId} />
